import {
  LayoutDashboard,
  Banknote,
  FileText,
  Users,
  Pill,
  CreditCard,
  Truck,
  CalendarRange,
  Upload,
  MessageSquare,
  Activity,
  RefreshCw,
  Send,
  Link2,
} from 'lucide-react';

export const ADMIN_TERMINAL_PHARMACY_IMPORT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_ADMIN_TERMINAL_PHARMACY_IMPORT_ENABLED || '').trim().toLowerCase(),
);

export const ADMIN_GASYSTEM_CP_IMPORT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_CP_IMPORT_ENABLED || '').trim().toLowerCase(),
);

export const MERCHANT_GASYSTEM_TERMINAL_IMPORT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_TERMINAL_IMPORT_ENABLED || '').trim().toLowerCase(),
);

export const MERCHANT_GASYSTEM_CUSTOMERS_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_CP_CUSTOMERS_ENABLED || '').trim().toLowerCase(),
);

export const GASYSTEM_PAYMENT_RESULTS_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_PAYMENT_RESULTS_ENABLED || '').trim().toLowerCase(),
);

export const GASYSTEM_CP_PAYMENT_RESULTS_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_CP_PAYMENT_RESULTS_ENABLED || '').trim().toLowerCase(),
);

export const ADMIN_CHECKOUT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_ADMIN_CHECKOUT_ENABLED || '').trim().toLowerCase(),
);

export const ADMIN_SMS_NOTIFICATION_ENABLED = Number(
  process.env.REACT_APP_RECEIPT_SMS_ENABLED ?? 0,
) === 1;

export const ADMIN_SINGLE_CP_MODE = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_ADMIN_SINGLE_CP_MODE || '').trim().toLowerCase(),
);

export const ADMIN_GNP_SHINSUNG_SYNC_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GNP_SHINSUNG_SYNC_ENABLED || '').trim().toLowerCase(),
);
export const ADMIN_CP_PAYOUT_TENANT_ENABLED =
  String(process.env.REACT_APP_BRAND_VARIANT || '').trim().toLowerCase() === 'phpay';

export const ADMIN_GASYSTEM_EXTERNAL_SETTLEMENT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_GASYSTEM_EXTERNAL_SETTLEMENT_ENABLED || '').trim().toLowerCase(),
);


export const MERCHANT_PHARMACY_ASSIGNMENT_ENABLED = ['EXCEL', 'SHINSUNG'].includes(
  String(process.env.REACT_APP_TERMINAL_PHARMACY_SOURCE || 'DISABLED').trim().toUpperCase(),
);


const isFeatureEnabled = (value, defaultValue = true) => !['0', 'false', 'no', 'n'].includes(
  String(value ?? (defaultValue ? '1' : '0')).trim().toLowerCase(),
);

export const TRANSACTION_PHARMACY_NAME_EDIT_ENABLED = isFeatureEnabled(
  process.env.REACT_APP_TRANSACTION_PHARMACY_NAME_EDIT_ENABLED,
);

export const MERCHANT_TERMINAL_REGISTRATION_ENABLED = isFeatureEnabled(
  process.env.REACT_APP_CP_TERMINAL_REGISTRATION_ENABLED,
);

export const MERCHANT_MANUAL_PAYMENT_ENABLED = isFeatureEnabled(
  process.env.REACT_APP_CP_MANUAL_PAYMENT_ENABLED,
);

export const MERCHANT_PAYMENT_LINKS_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_CP_PAYMENT_LINKS_ENABLED || '').trim().toLowerCase(),
);
/** 관리자 메뉴 */
export function getAdminMenu(
  excelImportEnabled = ADMIN_TERMINAL_PHARMACY_IMPORT_ENABLED,
  gasystemCpImportEnabled = false,
  gasystemPaymentResultsEnabled = GASYSTEM_PAYMENT_RESULTS_ENABLED,
) {
  return [
    { path: '/settlement', label: '정산', icon: <Banknote size={20} />, /* tooltip: '승인 건을 정산 확정하고 입금 처리하는 페이지입니다.' */ },
    ...(excelImportEnabled ? [{ path: '/terminal-pharmacy-import', label: 'Excel', icon: <Upload size={20} /> }] : []),
    ...(gasystemCpImportEnabled ? [{ path: '/gasystem-cp-import', label: '가맹점 일괄등록', icon: <Upload size={20} /> }] : []),
    { path: '/merchants', label: '관리', icon: <Users size={20} />, /* tooltip: '가맹점 정보 및 세금계산서를 관리하는 페이지입니다.' */ },
  // { path: '/tax-invoice', label: '세금계산서', icon: <FileText size={20} /> },
    { path: '/payments', label: '내역', icon: <CreditCard size={20} />, /* tooltip: '결제 내역을 조회하는 페이지입니다.' */ },
    ...(ADMIN_CHECKOUT_ENABLED ? [{ path: '/checkout', label: 'Checkout 운영 현황', icon: <Activity size={20} /> }] : []),
    ...(gasystemPaymentResultsEnabled ? [{ path: '/gasystem-payment-results', label: '결제 결과 전송', icon: <Send size={20} /> }] : []),
    ...(ADMIN_GNP_SHINSUNG_SYNC_ENABLED ? [{ path: '/shinsung-sync', label: '신성 동기화', icon: <RefreshCw size={20} /> }] : []),
    ...(ADMIN_SINGLE_CP_MODE ? [{ path: '/activity', label: '현황', icon: <Activity size={20} /> }] : []),
    ...(ADMIN_SMS_NOTIFICATION_ENABLED ? [{ path: '/sms', label: '알림', icon: <MessageSquare size={20} /> }] : []),
  // { path: '/pharmacies', label: '약국관리', icon: <Pill size={20} /> },
  ];
}

export const ADMIN_MENU = getAdminMenu();

/** 가맹점 메뉴 */
export const MERCHANT_MENU = [
  // { path: '/dashboard', label: '대시보드', icon: <LayoutDashboard size={20} /> },
  { path: '/integrated-settlement', label: '통합정산', icon: <CalendarRange size={20} /> },
  // { path: '/settlement-calendar', label: '정산달력', icon: <Banknote size={20} /> },
  // { path: '/payments', label: '결제내역', icon: <CreditCard size={20} /> },
  // { path: '/sugi', label: '수기결제', icon: <CreditCard size={20} />, openInPopup: true, popupWidth: 450, popupHeight: 750 },
  // { path: '/pharmacies', label: '약국관리', icon: <Pill size={20} /> },
  // { path: '/delivery', label: '배송계정', icon: <Truck size={20} /> },
];

/** 가맹점 메뉴 (v1: 헤더 중앙 메뉴) */
export const MERCHANT_MENU_V1 = [
  ...(ADMIN_SINGLE_CP_MODE
    ? [
        { path: '/delivery', label: '관리', icon: <Truck size={20} /> },
        { path: '/integrated-settlement', label: '정산', icon: <CalendarRange size={20} /> },
      ]
    : [
        { path: '/integrated-settlement', label: '정산', icon: <CalendarRange size={20} /> },
        { path: '/delivery', label: '영업자', icon: <Truck size={20} /> },
      ]),
  ...(MERCHANT_PHARMACY_ASSIGNMENT_ENABLED ? [{ path: '/pharmacies', label: '거래처', icon: <Pill size={20} /> }] : []),
  ...(MERCHANT_MANUAL_PAYMENT_ENABLED ? [{ path: '/sugi', label: '수기결제', icon: <CreditCard size={20} />, openInPopup: true, popupWidth: 450, popupHeight: 800 }] : []),
];

export function getMerchantMenu(
  pageVersion = 1,
  gasystemTerminalImportEnabled = false,
  gasystemCustomersEnabled = false,
  gasystemPaymentResultsEnabled = false,
  paymentLinksEnabled = false,
) {
  const baseMenu = Number(pageVersion) === 1 ? MERCHANT_MENU_V1 : MERCHANT_MENU;
  return [
    ...baseMenu,
    ...(gasystemCustomersEnabled
      ? [{ path: '/gasystem-customers', label: '거래처 목록', icon: <Pill size={20} /> }]
      : []),
    ...(gasystemTerminalImportEnabled
      ? [{ path: '/terminal-import', label: '담당자 일괄등록', icon: <Upload size={20} /> }]
      : []),
    ...(gasystemPaymentResultsEnabled
      ? [{ path: '/gasystem-payment-results', label: '전송 현황', icon: <Send size={20} /> }]
      : []),
    ...(paymentLinksEnabled
      ? [{ path: '/payment-links', label: '결제 링크', icon: <Link2 size={20} /> }]
      : []),
  ];
}

/** 앱 메뉴 */
export const APP_MENU = [
  { path: '/dashboard', label: '대시보드', icon: <LayoutDashboard size={20} /> },
  { path: '/payment', label: '결제', icon: <CreditCard size={20} /> },
  { path: '/payment-list', label: '결제내역', icon: <Banknote size={20} /> },
];
